import React, { Component } from 'react'
import FixedView from '../components/FixedView'
import IntractionActionsList from '../components/IntractionActionsList'
import SwitchButton from '../components/useful/SwitchButton'
import { translate } from '../utils/useful'

export default class NotebookOptions extends Component {
    state = {
        option: [
            { name: '{{lang}}notebook.rename', icon: '' },
            { name: '{{lang}}notebook.remove', icon: '' },
            { name: '{{lang}}notebook.Available', icon: '' },
        ]
    }

    opensize = (e) => {
        e.stopPropagation()
        this.size.showView()
    }
    render() {
        return (
            <div>
                <button className='p-1 br-5 hover-white2' onClick={(e) => this.opensize(e)} ref={el => this.SizeNode = el}>
                    <img className='flexcc' width={20} src='/assets/icons/more-gray.svg' />
                </button>
                <FixedView ref={el => this.size = el} nodeRef={this.SizeNode} showFocus={false} topOffset={2} xOffset={-10} zIndex={99}>
                    <div className='sc-1 shadow-2 br-10 p-2' style={{ backgroundColor: "#fff", width: "220px" }}>
                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Rename", icon: "/assets/icons/note/rename-note.svg" }} />
                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Remove", icon: "/assets/icons/note/trash-note.svg" }} />
                        <div className=''>
                            <button className='flexcb w-100 hover-gray2 p-2 br-10' onClick={this.lastPage}>
                                <div className='flexc hover-gray'>
                                    <img width={18} src='/assets/icons/note/availbe.svg' />
                                    <p className='font-size-12 weight-400 mld-3 main-c3 text-start'>{translate('notebook.Available offline')}</p>
                                </div>
                                <SwitchButton color={'#FFCC00'} />
                            </button>
                        </div>
                    </div>
                </FixedView>
            </div>
        )
    }
}
